// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-tags-container[data-v-ab872f9e]{padding:.5rem .25rem;display:block}.filterContainer[data-v-ab872f9e]{z-index:unset}.display-more-text[data-v-ab872f9e]{font-style:oblique}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
